<template>
  <div class="nw-button" :class="{actived:ac}" :style="{transform:dir==1?'skewx(25deg)':'skewx(-25deg)'}">
    <span :style="{transform:dir==1?'skewx(-25deg)':'skewx(25deg)'}">{{ name }}</span>
  </div>
</template>

<script>
import T from '@/utils/tools';
export default {
  components: {},
  props: {
    name: {
      type: String,
      default() {
        return '首页';
      }
    },
    dir:{
      type:[Number,String],
      default:1
    },
    ac:{
      type:[Boolean],
      default:false
    }
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.nw-button {
  background-image: linear-gradient(to bottom, #91bdf7 0%, #3a76d5 100%);
  opacity: 0.82;
  width: 82px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  border-radius: 3px;
  > span {
    color: white;
    display: block;
    font-weight: 600;
    letter-spacing: 1px;
  }
  &:hover{
    background-image: linear-gradient(to top, #0647A1 0%, #237BE6 100%);
    border-image: linear-gradient(360deg, rgba(253, 254, 255, 1), rgba(255, 255, 255, 0.59)) 1 1;
    border-bottom: 1px solid #FFFFFF;
    box-sizing: border-box;
  }
}
.actived{
  background-image: linear-gradient(to top, #0647A1 0%, #237BE6 100%);
  border-image: linear-gradient(360deg, rgba(253, 254, 255, 1), rgba(255, 255, 255, 0.59)) 1 1;
  border-bottom: 1px solid #FFFFFF;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/button.vue